import { createReducer } from '@reduxjs/toolkit';
import { TEXT_TO_SPEECH_VOICE, TEXT_TO_SPEECH_AUDIO_DATA } from '../constants';

const initState = {
  voiceId: '21m00Tcm4TlvDq8ikWAM', // Rachel default voice
  audioSrc: null,
  textOwnerId: null,
};

export default createReducer(initState, {
  [TEXT_TO_SPEECH_VOICE.SUCCESS](state, action) {
    return { ...state, ...action.payload };
  },
  [TEXT_TO_SPEECH_AUDIO_DATA](state, action) {
    return { ...state, ...action.payload };
  },
});
